export const applyColumnsOrder = <TColumn extends { key: string }>(
  srcColumns: TColumn[],
  columnsOrder: string[],
): TColumn[] => {
  const orderMap = new Map<string, number>(
    columnsOrder.map((key, index) => [key, index]),
  );

  return srcColumns.slice().sort((a, b) => {
    const orderA = orderMap.get(a.key) ?? Number.MAX_SAFE_INTEGER;
    const orderB = orderMap.get(b.key) ?? Number.MAX_SAFE_INTEGER;
    return orderA - orderB;
  });
};
